<template>
  <div>
    <div style="text-align:right;margin-bottom: 10px;">
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleCurrentChange(1)">刷新</el-button>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="姓名"
        min-width="120"
        prop="studentName">
      </el-table-column>
      <el-table-column
        label="手机号"
        width="140"
        prop="mobilePhone">
      </el-table-column>
      <el-table-column
        label="身份证"
        width="200"
        prop="idCardNo">
      </el-table-column>
      <el-table-column
        label="答卷成绩"
        width="100"
        prop="studentPaperScore">
      </el-table-column>
      <el-table-column
        :label="info.secondScoreName"
        width="100"
        prop="studentSecondScore">
      </el-table-column>
      <el-table-column
        :label="info.thirdScoreName"
        width="100"
        prop="studentThirdScore">
      </el-table-column>
      <el-table-column
        label="总分"
        width="100"
        prop="studentTotalScore">
      </el-table-column>
      <el-table-column
        label="状态"
        width="100"
        prop="status">
        <template slot-scope="{ row }">{{ row.status | studentScoreStatusame() }}</template>
      </el-table-column>
      <el-table-column
        label="是否通过"
        width="100"
        :formatter="row=> row.status === 3 ?(row.isPassing === 0 ? '不通过' : '通过') : '-'"
        prop="isPassing">
      </el-table-column>
      <el-table-column
        label="修改通过"
        width="80"
        prop="isPassing">
        <template slot-scope="{ row }">
          <el-button
            :disabled="!(row.status === 3 && row.isPassing === 0)"
            type="text"
            @click="setexamscorepass(row)">修改通过</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center;"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'StudentScoreTable',
  props: {
    id: { type: [Number, null], default: null },
    info: { type: Object, default() { return {} } }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 20 }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    setexamscorepass(row) {
      this.$confirm('您确定将该考生设为考试通过，该过程不可逆?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.setexamscorepass({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('设置成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getexamscores({ ...this.config, examId: this.id })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(item => {
              const {
                studentTotalScore, status, studentPaperScore, studentPaperScoreStatus, studentSecondScore,
                studentSecondScoreStatus, studentThirdScore, studentThirdScoreStatus
              } = item
              return {
                ...item,
                studentPaperScore: studentPaperScoreStatus === 3 ? studentPaperScore : '-',
                studentSecondScore: studentSecondScoreStatus === 3 ? studentSecondScore : '-',
                studentThirdScore: studentThirdScoreStatus === 3 ? studentThirdScore : '-',
                studentTotalScore: status === 3 ? studentTotalScore : '-'
              }
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
